import { RouteName } from "~/types/routes";
import type { IWorkspace } from "~/types/auth";

export default (key: string, forWorkspace?: IWorkspace) => {
  const hasService = forWorkspace
    ? (service: string) => forWorkspace.account.services.includes(service)
    : useServicesStore().hasService;

  const servicesStore = useServicesStore();

  const { clickCollectHasGroups } = storeToRefs(servicesStore);
  const accountIsBusiness = forWorkspace ? !!forWorkspace.account.business : useWorkspacesStore().accountIsBusiness;

  const isSKYNET = forWorkspace ? forWorkspace.account.level === "SKYNET" : useWorkspacesStore().isSKYNET;

  const hasCapability = forWorkspace
    ? (capability: string) => {
        const caps = forWorkspace.capabilities;
        if (!caps?.length) return false;
        if (caps.includes("owner")) return true;
        if (capability.endsWith("*")) {
          const start = capability.slice(0, -1);
          return caps.some((c) => c.startsWith(start));
        }
        return caps.includes(capability);
      }
    : useCapabilities().hasCapability;

  switch (key) {
    case RouteName.shipments:
    case RouteName.shipments_details:
      return hasCapability("shipments");
    case RouteName.shipments_label:
      return hasCapability("shipments.action.label.download");
    case RouteName.shipments_import:
    case RouteName.shipments_import_list:
      return hasCapability("shipments.import");
    case RouteName.consignments:
      return hasService("consignments");
    case RouteName.invoices:
      return !isSKYNET && (hasCapability("account.invoices") || hasCapability("account.invoices.edit"));
    case RouteName.documents:
      return hasCapability("account.documents") || hasCapability("account.documents.edit");
    case RouteName.prices:
      return (
        !isSKYNET &&
        !hasService("consignments") &&
        (hasCapability("account.prices") || hasCapability("account.prices.edit"))
      );
    case RouteName.returns:
      return hasService("returns") && hasCapability("service:returns");
    case RouteName.orders:
    case RouteName.orders_pack:
      return hasService("orders");
    case RouteName.tickets:
    case RouteName.tickets_details:
      return hasService("tickets") && hasCapability("service:ticket");
    case RouteName.sortings:
    case RouteName.sortings_direction:
      return hasService("pallets");
    case RouteName.sortings_terminal:
      return accountIsBusiness && hasCapability("service:sorting") && hasService("transfer");
    case RouteName.sortings_returning:
      return (accountIsBusiness && hasCapability("service:sorting") && hasService("transfer")) || hasService("pallets");
    case RouteName.click_collect:
      return hasService("clickcollect") && !!clickCollectHasGroups.value;
    case RouteName.purchase_orders:
    case RouteName.purchase_orders_details:
    case RouteName.seafreight:
    case RouteName.seafreight_details:
    case RouteName.containers:
    case RouteName.containers_details:
      return hasService("container");
    case RouteName.checkouts_analytics:
      return hasService("checkout_analytics");
    default:
      return true;
  }
};
